import React from "react"
import {useTranslation} from "react-i18next"
import {toast} from "react-toastify"

import {useSalesAssistantCreateCallMutation} from "../../queries/salesAssistant.ts"
import {getApiValidationMessages, isAxiosValidationError} from "../../utils/validation.ts"

// Asks Klara to call the linked sales person now and reports the outcome in a toast.
export function useCreateKlaraCall() {
  const {t} = useTranslation()
  const mutation = useSalesAssistantCreateCallMutation()
  const {mutateAsync} = mutation

  const createCall = React.useCallback(async () => {
    try {
      await mutateAsync()
      toast.success(t("KlaraDashboard_CallMeNow_SuccessToast"))
    } catch (e) {
      let message

      if (isAxiosValidationError(e)) {
        const getErrorMessage = (err: string) => {
          switch (err) {
            case "call_pending":
              return t("KlaraDashboard_CallMeNow_FailureToast_CallPending")
            case "deals_empty":
              return t("KlaraDashboard_CallMeNow_FailureToast_DealsEmpty")
            default:
              return err
          }
        }

        message = (
          <ul>
            {getApiValidationMessages(e.response.data, "errors").map((err, index) => (
              <li key={index}>{getErrorMessage(err)}</li>
            ))}
          </ul>
        )
      }

      toast.error(message)
    }
  }, [mutateAsync, t])

  return {createCall, isPending: mutation.isPending}
}
